import { ActionType } from '../core/redux/actionType';
import { Language } from './models';
import { makeApiAction, makeRsaaTypes, ApiReducer, makeApiReducer } from '../core/api/rsaa';
import { Endpoints } from '../core/api/endpoints';
import { getLoading, addLoading, addError, noLoadingNoError } from '../core/api/module';
import * as R from 'ramda';


const KEY_ACTION = ActionType.AllLanguagesRequest;
const ACTIONS    = [
  ActionType.AllLanguagesRequest,
  ActionType.AllLanguagesResponse,
  ActionType.AllLanguagesError,
];


type Payload = Language[];


/**
 * Dispatch this action to retrieve the user's security question (which they will have to answer in order to reset
 * their password)
 * @param emailAddress - the email address of the user whose security question we need to retrieve
 */
export const allLanguagesAction = makeApiAction<Payload>({
  method:   'POST',
  endpoint: Endpoints.AllLanguages,
  headers:  { 'content-type': 'application/json' },
  types:    makeRsaaTypes<Payload>(ACTIONS),
  bailout:  state => !!getLoading(state, KEY_ACTION),
});

const reducer: ApiReducer<Payload> = (state, action, errorMsg, isLoading, payload) => {
  if (isLoading) {
    return addLoading(state, KEY_ACTION);
  }

  if (errorMsg) {
    return addError(state, KEY_ACTION, errorMsg);
  }

  const successState = noLoadingNoError(state, KEY_ACTION);

  return R.assoc('allLanguages', payload, successState);
};


export const allLanguagesReducer = makeApiReducer<Payload>(ACTIONS, KEY_ACTION, reducer);
